import { Component, input, model, signal, ChangeDetectionStrategy } from "@angular/core";
import type { DisabledReason, FormValueControl, ValidationError, WithOptionalFieldTree } from "@angular/forms/signals";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { injectAddressFilterList } from "@jtms/default-connector/angular";

@Component({
  selector: "lib-address-search-contorl",
  imports: [MatAutocompleteModule, MatFormFieldModule, MatInputModule],
  templateUrl: "./address-search-contorl.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./address-search-contorl.component.css",
})
export class AddressSearchContorl implements FormValueControl<string> {
  // Required
  value = model<string>("");

  inputValue = signal<string>("");

  filteredOptions = injectAddressFilterList(() => ({
    query: this.inputValue(),
  }));

  displayFn(address: any | null): string {
    return address ? `${address.name}` : "";
  }

  // Writable interaction state - control updates these
  touched = model<boolean>(false);
  // Read-only state - form system manages these
  disabled = input<boolean>(false);
  disabledReasons = input<readonly WithOptionalFieldTree<DisabledReason>[]>([]);
  readonly = input<boolean>(false);
  hidden = input<boolean>(false);
  invalid = input<boolean>(false);
  errors = input<readonly ValidationError.WithOptionalFieldTree[]>([]);
}
